import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { loadReportsParams, OrderHistoryResultModel } from "@tKgpco/Services/ReportsService";
import { ReelQtyState } from "@tKgpco/Store/Data/Cart/CartReelQtyState";
import { ProductMultipleQtyState } from "@tKgpco/Store/Data/ProductMultipleQty/ProductMultipleQtyState";
import { ReportHistoryState } from "@tKgpco/Store/Data/ReportHistory/ReportHistoryState";
import { Draft } from "immer";

const initialState: ReelQtyState = {
    isReelQtyError: false,
};

export const reducer = {
    "Custom/Cart/DispatchSetReelQTYError": (draft: Draft<ReelQtyState>, action: { param: boolean }) => {
        draft.isReelQtyError = action.param;
    },
};
export default createTypedReducerWithImmer(initialState, reducer);
